import React from 'react';
import FlagIcon from './FlagIcon';
import './CountryChips.css';

// The 6 Gulf destination countries ADEL places into (see CLAUDE.md §1). Real flag SVGs via
// <FlagIcon> — emoji regional-indicator flags render as two-letter codes in boxes on Windows, so
// this is not a decorative UI icon, it's the only universally-rendering way to show an actual flag.
const COUNTRIES = [
  { label: 'All countries', value: '' },
  { label: 'Qatar', value: 'Qatar' },
  { label: 'UAE', value: 'UAE' },
  { label: 'Saudi', value: 'Saudi' },
  { label: 'Kuwait', value: 'Kuwait' },
  { label: 'Bahrain', value: 'Bahrain' },
  { label: 'Oman', value: 'Oman' },
];

export default function CountryChips({ value, onChange }) {
  return (
    <div className="cchips" role="group" aria-label="Filter jobs by country">
      {COUNTRIES.map((c) => (
        <button
          type="button"
          key={c.value}
          className={`cchip${value === c.value ? ' cchip-on' : ''}`}
          aria-pressed={value === c.value}
          onClick={() => onChange(c.value)}
        >
          <FlagIcon country={c.value} /> {c.label}
        </button>
      ))}
    </div>
  );
}
